module.exports = __webpack_public_path__ + "img/Korea.f73f834b.svg";